export const COMMISSION_PERMISSION = {
  ADD: 'SL_COMMISSION_ADD',
  EDIT: 'SL_COMMISSION_EDIT',
  VIEW: 'SL_COMMISSION_VIEW',
  DEL: 'SL_COMMISSION_DEL',
  REVIEW: 'SL_COMMISSION_REVIEW',
};

export const TYPE_VALUE = {
  MONEY: 1, // theo đ
  PERCENT: 2, // theo %
};

export const COMMISSION_CALCULATION_BASIS = {
  SALES: 0,
  DISTANCE: 1,
  PRODUCT: 2,
  FLAT: 3,
};

export const COMMISSION_CALCULATION_BASIS_OPTIONS = [
  { value: COMMISSION_CALCULATION_BASIS.SALES, label: 'Theo doanh số / tỷ lệ sản phẩm' },
  { value: COMMISSION_CALCULATION_BASIS.DISTANCE, label: 'Theo loại giao hàng và quãng đường' },
  { value: COMMISSION_CALCULATION_BASIS.PRODUCT, label: 'Theo ngành hàng / model / số lượng' },
  { value: COMMISSION_CALCULATION_BASIS.FLAT, label: 'Khoản cố định hoặc % giá trị đơn' },
];

export const DELIVERY_PROFILE_OPTIONS = [
  { value: 1, label: 'Đơn lẻ hoặc đơn 1-2 sản phẩm' },
  { value: 2, label: 'Đơn bộ từ 3 sản phẩm chính' },
  { value: 3, label: 'Đi dây/khoan ti trước' },
  { value: 4, label: 'Phát sinh giá loa/khoan loa' },
];

export const POLICY_CALCULATION_TYPE_OPTIONS = [
  { value: TYPE_VALUE.MONEY, label: 'Số tiền cố định' },
  { value: TYPE_VALUE.PERCENT, label: 'Phần trăm' },
];

export const POLICY_RULE_BASIS = {
  PRODUCT: 'PRODUCT',
  ORDER_REVENUE: 'ORDER_REVENUE',
  DELIVERY_DISTANCE: 'DELIVERY_DISTANCE',
  DELIVERY_MEAL: 'DELIVERY_MEAL',
  DELIVERY_OVERNIGHT: 'DELIVERY_OVERNIGHT',
};

export const POLICY_RULE_BASIS_OPTIONS = [
  { value: POLICY_RULE_BASIS.PRODUCT, label: 'Tip theo sản phẩm' },
  { value: POLICY_RULE_BASIS.ORDER_REVENUE, label: '% doanh số đơn' },
  { value: POLICY_RULE_BASIS.DELIVERY_DISTANCE, label: 'Tip quãng đường (quỹ chuyến)' },
  { value: POLICY_RULE_BASIS.DELIVERY_MEAL, label: 'Ăn trưa (theo người)' },
  { value: POLICY_RULE_BASIS.DELIVERY_OVERNIGHT, label: 'Qua đêm (theo người/đêm)' },
];

export const REVIEW_STATUS = {
  UNAPPROVED: 0, // chưa duyệt
  APPROVED: 1, // đồng ý duyệt
  REFUSE: 2, // từ chối duyệt
};

export const DIVIDE_BY = {
  BY_DEPARTMENT: 1,
  BY_SHIFT: 2,
  TO_SALE_EMPLOYEE: 3,
};

export const INIT_COMMISSION = {
  commission_name: '',
  is_active: 1,
  is_stopped: 0,
  type_value: TYPE_VALUE.MONEY,
  commission_value: 0,
  is_divide: DIVIDE_BY.BY_DEPARTMENT.toString(),
  is_divide_to_position: 0,
  business_apply: [],
  order_types: [],
  target_users: [],
  is_apply_all_user: 0,
  departments: [],
  position_list: [],
  stores: [],
  store_apply: [],
  commission_policy_category_id: null,
  commission_policy_category_code: null,
  commission_policy_category_name: null,
  commission_calculation_basis: COMMISSION_CALCULATION_BASIS.PRODUCT,
  policy_rules: [],
};

export const COMMISSION_STATUS = {
  NOT_APPROVED: 0,
  NOT_APPLIED: 1,
  CURRENTLY_APPLIED: 2,
  STOPPED: 3,
  APPROVED_DENIED: 4,
  ALL: 5,
};

export const COMMISSION_STATUS_OPTIONS = [
  {
    label: 'Tất cả',
    value: COMMISSION_STATUS.ALL,
  },
  {
    label: 'Chưa duyệt',
    value: COMMISSION_STATUS.NOT_APPROVED,
  },
  {
    label: 'Chưa áp dụng',
    value: COMMISSION_STATUS.NOT_APPLIED,
  },
  {
    label: 'Đang áp dụng',
    value: COMMISSION_STATUS.CURRENTLY_APPLIED,
  },
  {
    label: 'Dừng áp dụng',
    value: COMMISSION_STATUS.STOPPED,
  },
  {
    label: 'Từ chối duyệt',
    value: COMMISSION_STATUS.APPROVED_DENIED,
  },
];
